import { IconType } from 'components/Icon';
import ActionButton from 'components/Widget/ActionButton';
import { MenuItemAction } from 'menu/MenuItem';
import { useSelector } from 'react-redux';
import { selectActiveDesignSystem } from 'redux/db/reducers';
import { RootReducer } from 'redux/reducers';

const PublishAction = () => {
	const designSystem = useSelector((r: RootReducer) =>
		selectActiveDesignSystem(r.db, r.mode.activeDesignSystemId)
	);

	const onClick = () => {
		if (!designSystem) return;
		MenuItemAction.createPublishDs(designSystem.id, designSystem.title).callback();
	};

	return <ActionButton icon={IconType.LINE_ARROW_UP} label="Publish design system" onClick={onClick} />;
};

export default PublishAction;
